const convert = require('xml-js');

const MAX_NUMBER_OF_IMAGES = 4;

class MultiImageViewer {
	constructor(block) {
		this.multiImageViewerBlock = block;
		this.preloadSkeleton = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-preload-skeleton',
		);
		this.imagesGridBlock = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-images-grid',
		);
		this.placeholderImage = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-placeholder-image',
		);
		this.moreButton = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-more-button',
		);
		this.moreButtonNumber = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-more-button-number',
		);
		this.imagesGetUrl = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-get-images-url',
		).value;
		this.productSKU = this.multiImageViewerBlock.querySelector(
			'.js-multi-image-viewer-product-sku',
		).value;
		this.fullListOfImagesNames = [];
		this.modal = this.multiImageViewerBlock.querySelector(
			'.js-product-images-modal',
		);
		this.imagesCarouselInModal = this.modal?.querySelector(
			'.js-multi-image-viewer-carousel',
		);
		this.bigImageInModal = this.modal?.querySelector(
			'.js-multi-image-viewer-big-image',
		);
		this.navigationButtons = this.modal?.querySelectorAll(
			'.product-images-modal__navigation-icon',
		);
		this.activeImageClass = 'product-images-modal__carousel-item--is-active';
	}

	getFullListOfImages() {
		fetch(`${this.imagesGetUrl}?req=set`)
			.then(response => {
				return response.text();
			})
			.then(xmlText => {
				const jsonResult = convert.xml2js(xmlText, {
					compact: true,
					spaces: 2,
				});

				if (jsonResult.set?.item) {
					const items = Array.isArray(jsonResult.set.item)
						? jsonResult.set.item
						: [jsonResult.set.item];

					items.forEach(image => {
						const imageName = Object.values(image.i)[0].n.replace(
							'odeu13/',
							'',
						);
						if (imageName !== 'no_image') {
							this.fullListOfImagesNames.push(imageName);
						}
					});
				}

				this.displayElementsInsideMultiImageViewerBlock();
			})
			.catch(error => {
				console.log(error); // eslint-disable-line no-console
				this.displayElementsInsideMultiImageViewerBlock();
			});
	}

	getTrimmedUrlOfImages() {
		this.trimmedGetUrlOfImages = this.imagesGetUrl.replace(this.productSKU, '');
	}

	buildImagesGridItemMarkup(imageName) {
		this.getTrimmedUrlOfImages();

		const isVideo = imageName.indexOf('_v') >= 0;

		if (isVideo) {
			return `
				<div class="image-viewer__image-item js-multi-image-viewer-image" tabindex="0" id="${imageName}" data-toggle="modal" data-target="#allImagesModal">
					<picture>
						<source 
							type="image/webp"
							srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=466&wid=466&fmt=webp 1x,
							${this.trimmedGetUrlOfImages}${imageName}?hei=932&wid=932&fmt=webp 2x"
						>
						<source 
							type="image/jp2" 
							srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=466&wid=466&fmt=jpeg2000 1x,
							${this.trimmedGetUrlOfImages}${imageName}?hei=932&wid=932&fmt=jpeg2000 2x"
						>
						<img src="${this.trimmedGetUrlOfImages}${imageName}?hei=466&wid=466&fmt=webp" width="466" height="466" alt="${imageName}">
					</picture>

					<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g opacity="0.8">
							<rect width="56" height="56" rx="28" fill="#303030"/>
							<path d="M37 28L19 17.5V38.5L37 28Z" fill="white"/>
						</g>
					</svg>
				</div>
			`;
		}

		return `
			<div class="image-viewer__image-item js-multi-image-viewer-image" tabindex="0" id="${imageName}" data-toggle="modal" data-target="#allImagesModal">
				<picture>
					<source 
						type="image/webp"
						srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=466&wid=466&fmt=webp 1x,
						${this.trimmedGetUrlOfImages}${imageName}?hei=932&wid=932&fmt=webp 2x"
					>
					<source 
						type="image/jp2" 
						srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=466&wid=466&fmt=jpeg2000 1x,
						${this.trimmedGetUrlOfImages}${imageName}?hei=932&wid=932&fmt=jpeg2000 2x"
					>
					<img src="${this.trimmedGetUrlOfImages}${imageName}?hei=466&wid=466&fmt=webp" width="466" height="466" alt="${imageName}">
				</picture>
			</div>
		`;
	}

	getNumberOfImagesToDisplay() {
		if (this.fullListOfImagesNames.length >= MAX_NUMBER_OF_IMAGES) {
			return MAX_NUMBER_OF_IMAGES;
		}
		return this.fullListOfImagesNames.length;
	}

	buildImagesGridMarkup() {
		let imagesGridMarkup = '';
		const numberOfImages = this.getNumberOfImagesToDisplay();

		for (let i = 0; i < numberOfImages; i++) {
			imagesGridMarkup += this.buildImagesGridItemMarkup(
				this.fullListOfImagesNames[i],
			);
		}

		return imagesGridMarkup;
	}

	insertImagesGridMarkup() {
		this.imagesGridBlock.innerHTML = this.buildImagesGridMarkup();
	}

	displayImagesGridBlock() {
		this.imagesGridBlock.classList.remove(
			'image-viewer__images-grid--is-inactive',
		);
	}

	displayMoreButton() {
		this.moreButton.classList.remove('pill--is-inactive');
	}

	addNumberOfRemainImagesToMoreButton() {
		const numberOfRemainImages =
			this.fullListOfImagesNames.length - MAX_NUMBER_OF_IMAGES;
		this.moreButtonNumber.innerHTML = numberOfRemainImages;
	}

	hidePreloadSkeleton() {
		this.preloadSkeleton.classList.add(
			'image-viewer__preload-skeleton--is-inactive',
		);
	}

	displayPlaceholderImage() {
		this.placeholderImage.classList.remove(
			'image-viewer__placeholder-image--is-inactive',
		);
	}

	displayElementsInsideMultiImageViewerBlock() {
		if (this.fullListOfImagesNames.length > 0) {
			this.insertImagesGridMarkup();
			this.displayImagesGridBlock();

			if (this.fullListOfImagesNames.length > MAX_NUMBER_OF_IMAGES) {
				this.addNumberOfRemainImagesToMoreButton();
				this.displayMoreButton();
			}
		} else {
			this.displayPlaceholderImage();
		}

		this.hidePreloadSkeleton();
	}

	buildImagesCarouselItemMarkupInModal(imageName) {
		const isVideo = imageName.indexOf('_v') >= 0;

		if (isVideo) {
			return `
				<div class="product-images-modal__carousel-item js-multi-image-viewer-carousel-image" data-name="${imageName}" tabindex="0">
					<picture>
						<source 
							type="image/webp"
							srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=120&wid=120&fmt=webp 1x,
							${this.trimmedGetUrlOfImages}${imageName}?hei=240&wid=240&fmt=webp 2x"
						>
						<source 
							type="image/jp2" 
							srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=120&wid=120&fmt=jpeg2000 1x,
							${this.trimmedGetUrlOfImages}${imageName}?hei=240&wid=240&fmt=jpeg2000 2x"
						>
						<img loading="lazy" src="${this.trimmedGetUrlOfImages}${imageName}?hei=120&wid=120&fmt=webp" width="120" height="120" alt="${imageName}">
					</picture>

					<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g opacity="0.8">
							<rect width="50" height="50" rx="25" fill="#303030"/>
							<g clip-path="url(#clip0_8745_4122)">
								<path d="M31.75 25L18.25 17.125V32.875L31.75 25Z" fill="white"/>
							</g>
						</g>
						<defs>
							<clipPath id="clip0_8745_4122">
								<rect width="13.5" height="18" fill="white" transform="translate(18.25 16)"/>
							</clipPath>
						</defs>
					</svg>
				</div>
			`;
		}

		return `
			<button class="product-images-modal__carousel-item js-multi-image-viewer-carousel-image" data-name="${imageName}" tabindex="0">
              <picture>
                <source 
                  type="image/webp"
                  srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=120&wid=120&fmt=webp 1x,
                  ${this.trimmedGetUrlOfImages}${imageName}?hei=240&wid=240&fmt=webp 2x"
                >
                <source 
                  type="image/jp2" 
                  srcset="${this.trimmedGetUrlOfImages}${imageName}?hei=120&wid=120&fmt=jpeg2000 1x,
                  ${this.trimmedGetUrlOfImages}${imageName}?hei=240&wid=240&fmt=jpeg2000 2x"
                >
                <img loading="lazy" src="${this.trimmedGetUrlOfImages}${imageName}?hei=120&wid=120&fmt=webp" width="120" height="120" alt="${imageName}">
              </picture>
			</button>
		`;
	}

	buildImagesCarouselMarkupInModal() {
		let imagesCarouselMarkupInModal = '';

		for (let i = 0; i < this.fullListOfImagesNames.length; i++) {
			imagesCarouselMarkupInModal += this.buildImagesCarouselItemMarkupInModal(
				this.fullListOfImagesNames[i],
			);
		}

		return imagesCarouselMarkupInModal;
	}

	insertImagesCarouselMarkupInModal() {
		this.imagesCarouselInModal.innerHTML =
			this.buildImagesCarouselMarkupInModal();
	}

	getCarouselImages() {
		return this.imagesCarouselInModal?.querySelectorAll(
			'.js-multi-image-viewer-carousel-image',
		);
	}

	toggleClass(activeClass) {
		this.activeImage?.classList?.toggle(activeClass);
	}

	markActiveImageInCarousel(imageId) {
		const isArrowNavigation = document.activeElement?.classList?.contains(
			'product-images-modal__navigation-icon',
		);

		if (imageId) {
			this.activeImage = this.imagesCarouselInModal.querySelector(
				`[data-name="${imageId}"]`,
			);
		} else {
			const [, , , , fifthImage] = this.getCarouselImages();
			this.activeImage = fifthImage;
		}

		this.toggleClass(this.activeImageClass);

		if (!isArrowNavigation) setTimeout(() => this.activeImage?.focus(), 500);
	}

	scrollImagesCarouselToActiveImageInModal() {
		setTimeout(() => {
			if (window.innerWidth > window.innerHeight) {
				this.imagesCarouselInModal.scrollTo({
					left: 0,
					top: this.activeImage?.offsetTop,
					behavior: 'smooth',
				});
			} else {
				this.imagesCarouselInModal.scrollTo({
					left: this.activeImage?.offsetLeft,
					top: 0,
					behavior: 'smooth',
				});
			}
		}, '1000');
	}

	addSpinnerWhileLoadBigImageInModal() {
		this.bigImageInModal.classList.add(
			'product-images-modal__big-image--is-loading',
		);
	}

	removeSpinnerAfterLoadBigImageInModal() {
		this.bigImageInModal.classList.remove(
			'product-images-modal__big-image--is-loading',
		);
	}

	buildBigImageMarkupInModal(imageName) {
		if (typeof imageName !== 'string') return;

		if (imageName?.indexOf('_v') >= 0) {
			const trimmedGetUrlOfVideo = this.trimmedGetUrlOfImages.replace(
				'image',
				'content',
			);

			return `
				<video controls autoplay name="media">
					<source src="${trimmedGetUrlOfVideo}${imageName}" type="video/mp4">
				</video>`;
		}

		return `
			<picture>
				<source
					type="image/webp"
					srcset="${this.trimmedGetUrlOfImages}${imageName}?size=2000,2000&wid=2000&hei=2000&fmt=webp"
				>
				<source
					type="image/jp2"
					srcset="${this.trimmedGetUrlOfImages}${imageName}?size=2000,2000&wid=2000&hei=2000&fmt=jpeg2000"
				>
				<img src="${this.trimmedGetUrlOfImages}${imageName}?size=2000,2000&wid=2000&hei=2000&fmt=webp" width="2000" height="2000" alt="${imageName}">
			</picture>
		`;
	}

	insertBigImageMarkupInModal(imageId) {
		let imageToDisplay;

		if (imageId) {
			imageToDisplay = imageId;
		} else {
			const carouselImages = this.getCarouselImages();
			imageToDisplay = carouselImages?.[4]?.getAttribute('data-name');
		}

		this.bigImageInModal.innerHTML =
			this.buildBigImageMarkupInModal(imageToDisplay);
	}

	createMarkupInModal(e) {
		if (
			e.target.closest('.js-multi-image-viewer-image') ||
			e.target.classList.contains('js-multi-image-viewer-more-button')
		) {
			this.insertImagesCarouselMarkupInModal();
			this.addSpinnerWhileLoadBigImageInModal();
			this.markActiveImageInCarousel(
				e.target.closest('.js-multi-image-viewer-image')
					? e.target.closest('.js-multi-image-viewer-image').getAttribute('id')
					: '',
			);
			this.insertBigImageMarkupInModal(
				e.target.closest('.js-multi-image-viewer-image')
					? e.target.closest('.js-multi-image-viewer-image').getAttribute('id')
					: '',
			);
			this.scrollImagesCarouselToActiveImageInModal();
			this.initRemoveSpinnerAfterLoadBigImageInModal();
		}
	}

	initRemoveSpinnerAfterLoadBigImageInModal() {
		this.bigImageInModal.querySelector('img')?.addEventListener('load', () => {
			this.removeSpinnerAfterLoadBigImageInModal();
		});

		this.bigImageInModal
			.querySelector('video')
			?.addEventListener('loadeddata', () => {
				this.removeSpinnerAfterLoadBigImageInModal();
			});
	}

	dispatchClickEventOnMainImages(e) {
		if (e.target.closest('.js-multi-image-viewer-image')) {
			e.target
				.closest('.js-multi-image-viewer-image')
				.dispatchEvent(new Event('click', { bubbles: true }));
		}
	}

	changeActiveImageInModal(imageId) {
		this.addSpinnerWhileLoadBigImageInModal();
		this.toggleClass(this.activeImageClass);
		this.markActiveImageInCarousel(imageId);
		this.scrollImagesCarouselToActiveImageInModal();
		this.insertBigImageMarkupInModal(imageId);
		this.initRemoveSpinnerAfterLoadBigImageInModal();
	}

	zoomBigImageInModal(e, isKeyboardEvent) {
		if (
			window.innerWidth < 992 ||
			!this.bigImageInModal ||
			this.bigImageInModal?.querySelector('video')
		)
			return;

		if (
			e.target?.closest('.js-multi-image-viewer-image') ||
			e.target?.classList?.contains('js-multi-image-viewer-more-button')
		) {
			this.bigImageInModal?.classList?.remove(
				'product-images-modal__big-image--is-zoomed',
			);
			return;
		}

		if (
			e.target.closest('.js-multi-image-viewer-big-image') ||
			isKeyboardEvent
		) {
			this.bigImageInModal.classList.toggle(
				'product-images-modal__big-image--is-zoomed',
			);
		}
	}

	findActiveElement(showPreviousElement, isArrowsNav) {
		const currentElement = isArrowsNav
			? this.modal?.querySelector(`.${this.activeImageClass}`)
			: document.activeElement;

		const activeElement = showPreviousElement
			? currentElement?.previousElementSibling
			: currentElement?.nextElementSibling;

		return activeElement;
	}

	handleNavigation(showPreviousElement, isArrowsNav = false) {
		let activeElement = this.findActiveElement(
			showPreviousElement,
			isArrowsNav,
		);

		if (!activeElement) {
			const carouselImages = this.getCarouselImages();

			if (showPreviousElement)
				activeElement = carouselImages?.[carouselImages?.length - 1];

			if (!showPreviousElement && isArrowsNav)
				activeElement = carouselImages?.[0];

			if (!showPreviousElement && !isArrowsNav) {
				setTimeout(() => this.navigationButtons?.[0]?.focus());
				return;
			}
		}

		const imageId = activeElement?.getAttribute('data-name');

		this.changeActiveImageInModal(imageId);
	}

	initActionsInsideModal(e) {
		const imageId = e?.target
			?.closest('.js-multi-image-viewer-carousel-image')
			?.getAttribute('data-name');

		this.createMarkupInModal(e);
		if (imageId) this.changeActiveImageInModal(imageId);
		this.zoomBigImageInModal(e);
	}

	listeners() {
		this.getFullListOfImages();

		document.addEventListener('pointerup', e => {
			this.initActionsInsideModal(e);
		});

		document.addEventListener('keydown', e => {
			const keyEventInsideModal = document.activeElement?.classList?.contains(
				'js-multi-image-viewer-carousel-image',
			);
			const keyEventOnImageOutsideModal =
				document.activeElement?.classList?.contains(
					'js-multi-image-viewer-image',
				);

			if (!keyEventInsideModal && !keyEventOnImageOutsideModal) return;

			if (e.key === 'Tab' && keyEventInsideModal)
				this.handleNavigation(e.shiftKey);

			if (e.key === 'Enter' && keyEventInsideModal)
				this.zoomBigImageInModal(e, true);

			if (e.key === 'Enter' && keyEventOnImageOutsideModal) {
				this.dispatchClickEventOnMainImages(e);
				this.initActionsInsideModal(e);
			}
		});

		this.navigationButtons?.[0]?.addEventListener('click', () =>
			this.handleNavigation(true, true),
		);

		this.navigationButtons?.[1]?.addEventListener('click', () =>
			this.handleNavigation(false, true),
		);

		screen.orientation.addEventListener('change', () => {
			this.scrollImagesCarouselToActiveImageInModal();
		});

		window.addEventListener('resize', () => {
			this.scrollImagesCarouselToActiveImageInModal();
		});
	}

	init() {
		this.listeners();
	}
}

export default MultiImageViewer;
